import type { MotifComponent } from '../../motif/motifConstants';
import type { MotifComponentProps } from '../../motif/motifTypes';

export const defaultBreakVars: MotifComponentProps<MotifComponent.BREAK> = {
  '--break-total-desktop-height': '96px',
  '--break-half-desktop-height': '48px',
  '--break-total-mobile-height': '32px',
  '--break-half-mobile-height': '16px',
};
